__turbopack_context__.v({
  "marker": "minimap-module__febtRW__marker",
  "markers": "minimap-module__febtRW__markers",
  "minimap": "minimap-module__febtRW__minimap",
});
